import { DraftActionWithMemo } from '../types';

export const withoutHistory = (action: DraftActionWithMemo) => {
  action.noHistory = true;
  return action;
};
